import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'

type UnityPaymentTerm = {
  unity: {
    id: string
    name: string
  }
  paymentTerm: {
    id: string
    name: string
  }
}

type Response = {
  data: UnityPaymentTerm[]
  total: number
}

type Params = { proposalId: string }
const toastId = 'loadConfirmProposalData'

const fetcher = (params: Params): Promise<any> => {
  const { proposalId } = params
  return axios.get<Response>(`orders/${proposalId}/confirmations`)
}

export function useLoadConfirmProposalData(data: Params) {
  return useQuery(['loadConfirmProposalData', data], () => fetcher(data), {
    onError: () =>
      toast.error(
        'Não foi possível carregar os campos para validar o orçamento',
        {
          toastId: toastId,
          updateId: toastId
        }
      )
  })
}
